module.exports = __webpack_public_path__ + "static/djez_2-b7ec28493c47fdc00fa93a66dec9a8d1.jpg";